// Keep this dependency-free so telemetry can load it before application code.
export function isClientIntakeUrl(value: string | undefined): boolean {
  if (!value) return false;
  try {
    const url = new URL(value, "https://intake.invalid");
    const path = url.pathname;
    return /^\/intake(?:\/|$)/.test(path) || /^\/intake-api(?:\/|$)/.test(path) ||
      /^\/api\/admin\/smb\/client-intake(?:\/|$)/.test(path) ||
      (/^\/admin\/smb\/?$/.test(path) && (
        url.searchParams.getAll("view").includes("client-intake") ||
        ["intakeStatus", "intakeQ", "intakePage", "intakeId"].some(key => url.searchParams.has(key))
      )) || /(?:^|\/)client-intake\//.test(path);
  } catch {
    return false;
  }
}
